class CartNotificationClone extends HTMLElement {
  constructor() {
    super();

    this.freeDeliveryCustomEl = document.querySelector("free-delivery");
    this.closeBtn = document.querySelector(
      ".cart-notification-clone-close-btn",
    );
    this.notificationCustomEl = document.querySelector("cart-notification");
    this.notificationClone = document.getElementById("cart-notification-clone");
    this.notificationCloneWrapper = document.getElementById(
      "cart-notification-clone-wrapper",
    );
    this.notificationCloneProductList = document.getElementById(
      "cart-notification-clone-product-list",
    );
    this.notificationCloneSubtotal = document.getElementById(
      "cart-notification-clone-price-subtotal",
    );
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notificationCloneWrapper.addEventListener("click", (e) => {
      this.handleBodyClick(e);
    });

    this.closeBtn.addEventListener("click", (e) => {
      this.hideClone();
    });

    this.notificationClone.addEventListener("click", (e) => {
      if (e.target.classList.contains("cart-notification-clone-minus-btn")) {
        const quantityInput = e.target.parentElement.querySelector("input");
        e.target.parentElement.setAttribute("inactive", "");

        if (+quantityInput.value < 2) {
          this.sendUpdateRequest(
            quantityInput,
            0,
            +quantityInput.getAttribute("data-line-index"),
            "minus",
          );
          return;
        }

        this.sendUpdateRequest(
          quantityInput,
          +quantityInput.value - 1,
          +quantityInput.getAttribute("data-line-index"),
          "minus",
        );
      }
      if (e.target.classList.contains("cart-notification-clone-plus-btn")) {
        const quantityInput = e.target.parentElement.querySelector("input");
        e.target.parentElement.setAttribute("inactive", "");
        this.sendUpdateRequest(
          quantityInput,
          +quantityInput.value + 1,
          +quantityInput.getAttribute("data-line-index"),
          "plus",
        );
      }
    });
  }

  sendUpdateRequest(quantityInput, newQuantity, lineIndex = 0, action) {
    const updateConfig = {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({quantity: newQuantity, line: lineIndex}),
    };

    fetch(`${routes.cart_change_url}`, updateConfig)
      .then((response) => {
        if (newQuantity === 0)
          this.removeProductElement(quantityInput, lineIndex);
        this.updateQuantity(quantityInput, action);
        this.updateProductDetails(quantityInput);
        this.updateSubtotal();
        this.freeDeliveryCustomEl.checkDelivery(
          +this.notificationCloneSubtotal.getAttribute("data-subtotal"),
        );
        this.notificationCustomEl.fetchCartContents();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        quantityInput.parentElement.removeAttribute("inactive");
        this.addQuantityInputEvents();
      });
  }

  checkCartContents() {
    const cartItems = this.notificationCloneProductList.querySelectorAll(
      ".cart-notification-product--clone",
    );
    if (cartItems.length < 1) {
      this.notificationCloneProductList.innerHTML = `
        <span>${this.notificationCloneProductList.getAttribute(
          "data-cart-empty",
        )}</span>
      `;
    }
  }

  removeProductElement(quantityInput, lineIndex) {
    quantityInput.closest(".cart-notification-product--clone").remove();
    this.querySelectorAll(".cart-notification-clone-quantity").forEach(
      (quantity) => {
        const quantityIndex = +quantity.getAttribute("data-line-index");
        if (quantityIndex > lineIndex) {
          quantity.setAttribute("data-line-index", quantityIndex - 1);
        }
      },
    );
    this.checkCartContents();
  }

  updateProductDetails(quantityInput) {
    const priceTags = quantityInput
      .closest("quantity-input")
      .parentElement.querySelectorAll(
        ".cart-notification-product__details-price--clone",
      );
    priceTags.forEach((tag) => {
      const tagMoneyEl = tag.querySelector(".money");
      const previousTotal = tag.getAttribute("data-product-price-total");
      const newTotal = (
        quantityInput.value * +tag.getAttribute("data-product-price")
      ).toFixed(2);
      tag.setAttribute("data-product-price-total", newTotal);
      tagMoneyEl.textContent = tagMoneyEl.textContent.replace(
        previousTotal,
        newTotal,
      );
    });
  }

  updateSubtotal() {
    const subTotal = [
      ...this.querySelectorAll(".cart-notification-product__details-new-price"),
    ]
      .reduce(
        (acc, productPrice) =>
          Number(productPrice.getAttribute("data-product-price-total")) + acc,
        0,
      )
      .toFixed(2);
    const previousTotal =
      this.notificationCloneSubtotal.getAttribute("data-subtotal");
    this.notificationCloneSubtotal.textContent =
      this.notificationCloneSubtotal.textContent.replace(
        previousTotal,
        subTotal,
      );
    this.notificationCloneSubtotal.setAttribute("data-subtotal", subTotal);
  }

  updateQuantity(quantityInput, action) {
    if (action === "plus") quantityInput.value = +quantityInput.value + 1;
    if (action === "minus") quantityInput.value = +quantityInput.value - 1;
    quantityInput.setAttribute("value", quantityInput.value);


  }

  addQuantityInputEvents() {
    this.notificationCloneQuantities = document.querySelectorAll(
      ".cart-notification-clone-quantity",
    );

    this.notificationCloneQuantities.forEach((input) => {
      // Elements can be revisited when the drawer reopens; bind only once.
      if (input.dataset.alternixQuantityBound === 'true') return;
      input.dataset.alternixQuantityBound = 'true';
      input.addEventListener("keyup", (e) => {
        const quantityInput = e.target;
        setTimeout(() => {
          if (e.target.value > 0) {
            e.target.parentElement.setAttribute("inactive", "");
            this.sendUpdateRequest(
              quantityInput,
              +quantityInput.value,
              +quantityInput.getAttribute("data-line-index"),
            );
          } else {
            e.target.parentElement.setAttribute("inactive", "");
            this.sendUpdateRequest(
              quantityInput,
              0,
              +quantityInput.getAttribute("data-line-index"),
              "minus",
            );
            return;
          }
        }, 1000);
      });
    });
  }

  showClone() {
    this.notificationCloneWrapper.classList.add("active");
    this.freeDeliveryCustomEl.checkDelivery(
      +this.notificationCloneSubtotal.getAttribute("data-subtotal"),
    );

    this.addQuantityInputEvents();
  }

  hideClone() {
    this.notificationCloneWrapper.classList.remove("active");
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notificationClone &&
      !target.closest("#cart-notification-clone")
    ) {
      this.hideClone();
    }
  }
}

customElements.define("cart-notification-clone", CartNotificationClone);

class CartNotificationRecommendation extends HTMLElement {
  constructor() {
    super();

    this.cartRecQuantityWrapper = this.querySelector(
      ".cart-notification-rec-quantity",
    );
    this.cartRecQuantityInput =
      this.cartRecQuantityWrapper.querySelector("input");
    this.cartRecProductPrice = this.querySelector(
      ".cart-notification-rec-product-price",
    );

    this.cartRecQuantityWrapper.addEventListener("click", (e) => {
      if (e.target.classList.contains("cart-notification-rec-plus-btn")) {
        this.updateQuantity();
        return;
      }

      if (e.target.classList.contains("cart-notification-rec-minus-btn")) {
        this.updateQuantity("minus");
        return;
      }
    });
  }

  resetPrice() {}

  updatePrice(newQuantity) {
    const oldPrice = this.cartRecProductPrice.getAttribute(
      "data-product-price-total",
    );
    const newPrice =
      +this.cartRecProductPrice.getAttribute("data-product-price") *
      newQuantity;
    this.cartRecProductPrice.textContent =
      this.cartRecProductPrice.textContent.replace(
        oldPrice,
        newPrice.toFixed(2),
      );
    this.cartRecProductPrice.setAttribute(
      "data-product-price-total",
      newPrice.toFixed(2),
    );
  }

  updateQuantity(action = "plus") {
    if (action === "plus") {
      const newQuantity = +this.cartRecQuantityInput.value + 1;
      this.cartRecQuantityInput.value = newQuantity;
      this.cartRecQuantityInput.setAttribute("value", newQuantity);
      this.updatePrice(newQuantity);
      return;
    }

    if (action === "minus" && +this.cartRecQuantityInput.value > 1) {
      const newQuantity = +this.cartRecQuantityInput.value - 1;
      this.cartRecQuantityInput.value = newQuantity;
      this.cartRecQuantityInput.setAttribute("value", newQuantity);

      this.updatePrice(newQuantity);

      return;
    }
  }
}

customElements.define(
  "cart-notification-recommendation",
  CartNotificationRecommendation,
);